import Request from "../../utils/Request";
import { AxiosResponse } from "axios";

/**
 * @returns {Promise<AxiosResponse<T>>}
 * @param id
 */
const DeletePastPapdisUpload = (id: number): Promise<AxiosResponse<*>> =>
{
	return Request.delete(`/advisors/delete-past-papdis-upload/${id}`);
}

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export default DeletePastPapdisUpload;
